module.exports = __webpack_public_path__ + "static/media/warning_orange.a944d516.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/share/warning_orange.svg
// module id = 515
// module chunks = 4